export enum ActionType {
    Accepted = 'Accepted',
    Skipped = 'Skipped',
    Read = 'Read'
}

export enum Portal {
    Account = 3,
    Corporate = 1
}

export enum DocumentCategoryType {
    CompanyPolicy = 2,
    CheckoutPolicy = 6
}
export enum DisplaySectionId {
    Shopping_Bag = 1,
    Sign_up = 2,
    Profile = 3,
    Payment = 4,
    MyAction_Center = 5

}

export enum DocumentType {
    PDF = 71,
    Word = 83
}
